export default __webpack_public_path__ + "static/media/sad.022c0a5e.svg";